import React, { useState, useEffect, createRef, useLayoutEffect } from 'react'
import { Row, Col, Form, Card, Button, Select } from 'antd'
import { useLocation, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import * as XLSX from 'xlsx'
import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import FileUpload from 'components/fileUpload'
import FileUploadXls from 'components/FileUploadXls'
import WarningModal from 'components/WarningModal'
import AmountField from 'components/AmountField'
import CustomTooltip from 'components/Tooltip'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import { getCurrentCompany } from '../../../../../services/user'
import {
  setTableDataSalary,
  setSelectedOption,
  editTableDataSalary,
} from 'store/actions/salary'
import { checkAmountForRequest, convertBase64, roundSalaryAmount } from '../../../../../services/helper'
import NextModal from 'components/NextModal'

import {
  DownloadBtnIco,
  MinusSmallIco,
  PlusSmallIco,
  NoticeLinedIco,
  NoticeIco,
} from '../../../../../../modules/CustomIcons'
import { getCustomerCommission } from '../../../../../services/Customers/Commission'

import '../index.scss'
import '../../../../Transfer/transfer.scss'
import { useActions } from '../../../../../hooks/useActions'
import { BUTTONS, TemplateSalaryExcell } from 'constants/constants'
import { financial } from '../../../../../services/helper'
import { uploadFile } from "../../../../../services/Transfers/Files";
import NextModalSalary from "components/NextModalSalary/NextModalSalary";
import { useTranslation } from 'react-i18next'
import SelectField from "components/SelectField";
import FullScreenLoading from "components/FullScreenLoading";
import {getMessageList} from "../../../../../services/info";

const TransferInputs: React.FC<any> = ({
  removeFile,
  newTransferFunc,
  editedTableValue,
  form,
  onFieldsChange,
  onFinish,
  onFinishFailed,
  getSelectedFromBranch,
  fromBranch,
  modalData,
  maindet,
  nextModalVisible,
  fromSelectOptions,
  setNextModalVisible,
  documentNumber,
  companyData,
  disabledCreate,
  employeData,
  createdTransferValue
}) => {
  const {t} = useTranslation();
  const formRef = createRef()
  const location = useLocation()
  const { setTableDataSalary, editTableDataSalary } = useActions()
  const [visible, setVisible] = useState(false)
  const [visibleModal, setVisibleModal] = useState(false)
  const [uploadedFile, setUploadedFile] = useState([])
  const [commissionLoading, setCommissionLoading] = useState(false)
  const [tableDataXls, setTableXls] = useState([])
  const [commissionAmount, setCommissionAmount] = useState('0.00')
  const [amount, setAmount] = useState(0)
  const [visibleErrorMessage, setVisibleErrorMessage] = useState(false)
  const [fileList, setFileList] = useState([])
  const [FileSend, setFileSend] = useState<any[]>([])
  const [optionsDet, setOptionsDet] = useState<any[]>([])
  const [showSpinner, setShowSpinner] = useState<boolean>(false)
  const [isTouched, setIsTouched] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [maindetail,setMainDet] = useState<any>(maindet||'')
  const language = localStorage.getItem("i18nextLng")

  const fetchDataDropList = async () => {
    try {
      const data = await getMessageList();
      const lang = (language || 'az').slice(0, 2).toLowerCase();
      let temp_data: any[] = [];
      if (data?.messageList !== undefined && data?.messageList !== null && data.messageList.length > 0) {
        for (let row of data.messageList) {
          if (row.messageKey && row.messageKey.toString().includes("DROP.SALARY_")) {
            let labelText;
            switch (lang) {
              case 'ru':
                labelText = row.textRU;
                break;
              case 'en':
                labelText = row.textENG;
                break;
              case 'az':
              default:
                labelText = row.textAZE;
            }
            // Fall back to any available translation so a missing localized
            // field never yields an empty option.
            labelText = labelText || row.textAZE || row.textENG || row.textRU;
            if (labelText) {
              temp_data.push({
                label: labelText,
                value: labelText,
              });
            }
          }
        }
      }

      setOptionsDet(temp_data);
    } catch (e) {
      // Don't let a failed fetch silently leave the dropdown empty with no trace.
      console.error('Salary MAINDET dropdown fetch failed', e);
    }
  };

  useEffect(() => {
   
    setMainDet(maindet)
    if (!form.getFieldValue('MAINDET') && createdTransferValue.length) {
      form.validateFields(['MAINDET'])
    }
  }, [form.getFieldValue('MAINDET'),createdTransferValue.length]);

  useEffect(()=>{
    fetchDataDropList();
  },[language])
  const propsUpload = {
    multiple: false,
    accept: '.xls, .xlsx',
    maxCount: 1,
    showUploadList: {
      showDownloadIcon: false,
      removeIcon: <div />,
      // maxCount: 1,
      showPreviewIcon: false,
    },
    onRemove: (event, file: any) => {
      event.stopPropagation()
      const index = fileList.indexOf(file)
      const newFileList: any = fileList.slice()
      newFileList.splice(index, 1)
      removeFile()
      return setFileList(newFileList)
    },
    beforeUpload: (file: any) => {
      let fileListArr = []
      fileListArr.push(file)
      setFileList(fileListArr)
      return false
    },
    onChange(info: any) {
      if (info.file.type !== 'application/vnd.ms-excel' && info.file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        setVisibleModal(true)
      } else {
        const listFiles = info.fileList.slice(-3)
        const newArrayFiles = listFiles.map((file: any) =>
          file.originFileObj ? file.originFileObj : file
        )
        const anAsyncFunction = async (item: any) => {
          return convertBase64(item)
        }

        const getData = async () => {
          return Promise.all(
            newArrayFiles.map((item: any) => anAsyncFunction(item))
          )
        }
        getData().then((data) => {
          setFileSend(data)
        })
      }
    },
    fileList: fileList,
  }

  useEffect(() => {
    editTableDataSalary([])
    setAmount(0)
  }, [location])

  const innerColumnsdata = [
    {
      title: <div style={{ display: 'flex', alignItems: 'center' }}>№</div>,
      width: 60,
      ellipsis: true,
      editable: false,
      dataIndex: 'key',
      key: 'key',
      sorter: (a: any, b: any) => a.key - b.key,
      render: (record: string, text: any, index: number) => {
        return <p>{index + 1}</p>
      },
    },
    {
      title: t("salary.accountHolder"),
      dataIndex: 'name',
      key: 'name',
      editable: false,
      width: 160,
      ellipsis: true,
      render: (text: string, record: any, index: number) => {
        if (employeData && employeData.some((e) => e.EMPLACC === record.account)) {
          const employee = employeData.find((e) => e.EMPLACC === record.account);
          return <p>{employee.EMPLNAME}</p>;
        } else {
          return <p>{text}</p>; // Render 'owner' or default text if no match found
        }
      },
    },
    {
      title: t("salary.employeeAccountNumber"),
      dataIndex: 'account',
      key: 'account',
      editable: false,
      width: 284,
      ellipsis: true,
    },
    {
      title: t("common.amount"),
      dataIndex: 'amount',
      key: 'amount',
      editable: false,
      width: 120,
      maxWidth: 120,
      ellipsis: true,
      render: (text: string) => {
        return (
          <div style={{ textAlign: 'center', maxWidth: 120,marginRight:70 }}>
            {financial(text)}
          </div>
        )
      },
    },
    {
      title: t("transfers.details"),
      dataIndex: 'description',
      key: 'description',
      editable: false,
      width: 230,
      ellipsis: true,
      render: (text: string,row:any) => {

        return <p style={{ maxWidth: 169 }}>{modalData.groups[0]?.data[6]?.value}</p>
      },
    },
    {
      title: t("newTransfer.note"),
      dataIndex: 'notification',
      key: 'notification',
      width: 137,
      ellipsis: true,
      editable: false,
      render: (text: string, record: any) => {
        return text ? (
          <CustomTooltip title={record.notification && record.notification.length < 180 ? record.notification : record.notification.substring(0, 10)}>
            <Button>
              <NoticeLinedIco />
            </Button>
          </CustomTooltip>
        ) : (
          <Button>
            <NoticeIco />
          </Button>
        )
      },
    },
  ]

  const saveFiles = async () => {
    let fileDetailsList = {
      'fileDetailsList': []
    };
    if (fileList.length > 0) {
      for (let file of fileList) {
        // let convert = await convertBase64(file);
        //  console.log(fileBase64)
        let convert = await convertBase64Xls(file);
        fileDetailsList['fileDetailsList'].push({
          fileBase64: convert.replace("data:application/vnd.ms-excel;base64,", ""),
          pmtid: documentNumber,
          fileName: file.name,
          mimeType: file.type
        })
      }

      uploadFile(fileDetailsList);
    }

  }

  const handleUpload = () => {
    let temp_array: Array<any> = []
    // const specialCharRegexRu = new RegExp("[а-яА-ЯЁё.!@ ,-]");

    let detail= form.getFieldValue('PMTDET') !== undefined ? form.getFieldValue('PMTDET'):''
      tableDataXls.map((row: any, index: number) => {

        if(row.__EMPTY_25 && row.__EMPTY_25==='old'){


          temp_array.push({

                  number: index + 1,
                  key: index + 1,
                  name: row.__EMPTY_1,
                  owner: row.__EMPTY_8,
                  account: row.__EMPTY_2,
                  // Normalize the separator and apply the qapik rounding rule
                  // (3rd decimal digit >= 5 -> +0.01) so pasted/exported Excel
                  // amounts like "12.55555555" become "12.56".
                  amount: roundSalaryAmount(row.__EMPTY_3),
                  description:form.getFieldValue('MAINDET')+" "+detail,
                  notification: row.__EMPTY_5 && row.__EMPTY_5.length > 180 ? row.__EMPTY_5.substring(0, 180) : row.__EMPTY_5,
                  status: row.__EMPTY_2,
                })
        }else{
          temp_array.push({
            number: index + 1,
            key: index + 1,
            name: row.__EMPTY_1,
            owner: row.__EMPTY_8,
            account: row.__EMPTY_2,
            // Normalize the separator and apply the qapik rounding rule
            // (3rd decimal digit >= 5 -> +0.01) so pasted/exported Excel
            // amounts like "12.55555555" become "12.56".
            amount: roundSalaryAmount(row.__EMPTY_3),
            description:form.getFieldValue('MAINDET')+" "+detail,
            notification: row.__EMPTY_4 && row.__EMPTY_4.length > 180 ? row.__EMPTY_4.substring(0, 180) : row.__EMPTY_4,
            status: row.__EMPTY_2,
          })
        }


      })

      console.log("ke",temp_array);
      
    editTableDataSalary(temp_array)
    setTableDataSalary(uploadedFile)
  }

  const convertBase64Xls = (file: File) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader?.result)
      }
      fileReader.onerror = (error) => {
        reject(error)
      }
    })
  }

  const convertBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)
      fileReader.onload = () => {

        var bufferArray = fileReader?.result

        const wb = XLSX.read(bufferArray, { type: 'array' })

        const wsname = wb.SheetNames[0]
        const ws = wb.Sheets[wsname]
        // const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
        if (
          wb.Sheets.HidSh &&
          wb.Sheets.HidSh.CW101 &&
          wb.Sheets.HidSh.CW101.v == '1' &&
          wb.Sheets.No_rename
        ) {
          const data = XLSX.utils.sheet_to_json(ws)
          var filteredXls = data.filter(function (value, index, arr) {
            return value.__EMPTY !== ''
          })

          var filteredXlsData = data
              .filter(function (value, index, arr) {
                return !isNaN(value.__EMPTY) || !value.__EMPTY
              })
              .filter((data) => {
                return data.__EMPTY !== ''
              })
          if (filteredXls.length == 1 || filteredXls.length <= 3) {
            setVisibleModal(true)
          }

          if ('A1' in ws || 'A2' in ws || 'A3' in ws || 'A4' in ws || 'A5' in ws || 'A6' in ws || 'A7' in ws || 'B1' in ws || 'B2' in ws || 'B3' in ws || 'B4' in ws || 'B5' in ws || 'B6' in ws || 'B7' in ws || 'C1' in ws || 'C2' in ws || 'C3' in ws || 'C4' in ws || 'C5' in ws || 'C6' in ws || 'C7' in ws || !('E6' in ws) || !('D6' in ws)) {
            setVisibleModal(true)
          }

          setUploadedFile(filteredXls)
          setTableXls(filteredXlsData)
          resolve(data)
        }else{
          const data = XLSX.utils.sheet_to_json(ws)

          var filteredXls = data.filter(function (value, index, arr) {
            return value.__EMPTY !== ''
          })

          var filteredXlsData = data
              .filter(function (value, index, arr) {
                return !isNaN(value.__EMPTY) || !value.__EMPTY
              })
              .filter((data) => {
                return data.__EMPTY !== ''
              })
          var newRowIndex = 'newRow';
          var newRowData = {
            ...filteredXlsData[0],
            __EMPTY_25: 'old', // Yeni satır verileri
            // Diğer özellikler
          };

          filteredXlsData[0] = newRowData;
          if (filteredXls.length == 1 || filteredXls.length <= 3) {
            setVisibleModal(true)
          }

          if ('A1' in ws || 'A2' in ws || 'A3' in ws || 'A4' in ws || 'A5' in ws || 'A6' in ws || 'A7' in ws || 'B1' in ws || 'B2' in ws || 'B3' in ws || 'B4' in ws || 'B5' in ws || 'B6' in ws || 'B7' in ws || 'C1' in ws || 'C2' in ws || 'C3' in ws || 'C4' in ws || 'C5' in ws || 'C6' in ws || 'C7' in ws || !('E6' in ws) || !('D6' in ws)) {
            setVisibleModal(true)
          }

          setUploadedFile(filteredXls)
          setTableXls(filteredXlsData)
          resolve(data)
        }

      }
      fileReader.onerror = (error) => {
        reject(error)
      }
    })
  }

  const getFileList = (info: any) => {
    form.setFieldsValue({
      pdf_files: info.fileList,
    })
  }

  const calculateCommission = (valueData: number) => {
    setShowSpinner(true)
    let value = checkAmountForRequest(valueData)

    if (!isNaN(value)) {
      setCommissionLoading(true)
      let detail= form.getFieldValue('PMTDETAIL') !== undefined ? form.getFieldValue('PMTDETAIL'):''

      getCustomerCommission({
        PAYMENT_TYPE: 'SALARY_TOTAL',
        CIF: companyData,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: value,
        CUR: fromBranch?.CCY_NAME,
        BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
        BENEFACC: form.getFieldValue('CUSTACC'),
        BENEFTAXID: form.getFieldValue('BENEFTAXID'),
        PMTDET: form.getFieldValue('MAINDET')+" "+detail,
      }).then((res) => {
        setCommissionLoading(false)

        form.setFieldsValue({
          COMMISSION: financial(res.COM_AMOUNT),
        })
        setCommissionAmount(() => financial(res.COM_AMOUNT))
        setShowSpinner(false)
      })
    } else {
      setCommissionLoading(false)

      form.setFieldsValue({
        COMMISSION: '0.00',
      })

      setCommissionAmount(() => '')
    }
  }

  const sumAmount = () => {
    let sum = 0
    editedTableValue.map((item: any) => {
      if (isNaN(item.amount) || item.amount == '') {
        return 0
      } else {
        sum += parseFloat(item.amount)
      }
    })
    return sum
  }

  useEffect(() => {
    if (form.getFieldValue('PMTCUSTID') && form.getFieldValue('CUSTACC') && editedTableValue.length > 0) {
      calculateCommission(amount)
    }
  }, [form.getFieldValue('CUSTACC'), form.getFieldValue('PMTCUSTID')])

  useLayoutEffect(() => {
    if (editedTableValue.length !== 0) {
      // do things after first render
      let amountResult = sumAmount()
      if (amountResult && form.getFieldValue('CUSTACC')) {
        calculateCommission(amountResult)
      }
      setAmount(amountResult)
    }
  }, [editedTableValue])

  useLayoutEffect(() => {
    if (editedTableValue.length == 0) {
      setFileList([])
      setAmount(0)
      setCommissionAmount('')
    }
  }, [editedTableValue])

  const handleMainDet= (value:any)=>{
    setMainDet(value)
    setIsTouched(true);
    setHasError(value === null || value === undefined);
    // The Select overrides the Form.Item binding (it has its own value/onChange),
    // so antd's Form never learns MAINDET was filled and keeps the required-field
    // error red. Push the value into the form and re-validate to clear it.
    form.setFieldsValue({ MAINDET: value });
    if (value !== null && value !== undefined && value !== '') {
      form.setFields([{ name: 'MAINDET', errors: [] }]);
    }
  }
  const handleCloseModal = () => {
    setVisibleModal(false)
    setFileList([])
  }

  function downloadExcel() {
    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${TemplateSalaryExcell}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = 'SalaryTemplate'
    downloadLink.click()
  }

  useEffect(() => {
    if (!form.getFieldValue('CUSTACC') && createdTransferValue.length) {
      form.validateFields(['CUSTACC'])
    }
  }, [form.getFieldValue('CUSTACC')]);

  // console.log("aec", editedTableValue);
  
  return (
    <>
      <WarningModal
        visibleModal={visibleModal}
        onOk={() => handleCloseModal()}
        onCancel={() => handleCloseModal()}
      />
      {/* <SuccessOrErrorModal
          title={t("common.error")}
          modalType={'error'}
          modalText={'Yalnız xls tipli fayl yüklənməlidir.'}
          visible={visibleErrorMessage}
          onClose={() => {
            setVisibleErrorMessage(() => false)
          }}
        /> */}
      <Row className="rowflex">
        <Col flex={'700px'} className="own-account">
          <Card bordered={false} className="salary-card">
            <Row justify="start" className="own-account__form">
              <Form
                labelCol={{ flex: '190px'}}
                wrapperCol={{ flex: 5 }}
                className="full"
                form={form}
                id="myForm"
                onFieldsChange={onFieldsChange}
                onFinish={onFinish}
                name="basic"
                initialValues={{ remember: true }}
                onFinishFailed={onFinishFailed}
                scrollToFirstError={{
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                }}
              // onFinish={handleSalaryTransfer}
              >
                <div className="flex">
                  <InputField
                    required
                    name="PMTCUSTID"
                    labelItem={t("salary.documentNo")}
                    placeholder={t("salary.automatically")}
                    form={form}
                    value={documentNumber}
                    message={true}
                    maxLength={25}
                    allowLatinNumber ={true}
                  />
                </div>
                <Form.Item
                    label={t("transfers.fromAccount")} name={'CUSTACC'}
                  rules={[
                    {
                      required: true,
                      message: t("transfers.selectAccount"),
                    },
                  ]}
                >
                  <Select
                    size="large"
                    placeholder={t("accountStatement.chooseAccount")}
                    optionFilterProp={'value'}
                    onChange={getSelectedFromBranch}
                    listItemHeight={10}
                    // listHeight={250}
                  >
                    {fromSelectOptions?.map((row: any, index: number) => {
                      return (
                        //@ts-ignore
                        <Option key={index} value={row.value}>
                          {row.label} {row.extra && <span>{row.extra}</span>}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>

                {/*<SelectField*/}
                {/*    labelItem={t("transfers.fromAccount")}*/}
                {/*    placeholder={t("accountStatement.chooseAccount")}*/}
                {/*    options={fromSelectOptions}*/}
                {/*    name={'CUSTACC'}*/}
                {/*    // onChange={getSelectedFromBranch}*/}
                {/*    required={true}*/}
                {/*    form={form}*/}
                {/*    account={true}*/}
                {/*    notFoundContent={t("newTransfer.noAccountCorrespondingCurrency")}*/}
                {/*    // defaultValue={ibanNumber.iban}*/}
                {/*/>*/}

                <div className={'flex justify_between'}>
                  <AmountField
                    labelItem={t("common.amount")}
                    placeholder=""
                    suffix={fromBranch?.CCY_NAME}
                    name={'PMTAMOUNT'}
                    className={
                      'amount_and_commission_col amount_input dark-input'
                    }
                    required={true}
                    readOnly={true}
                    form={form}
                    value={financial(amount)}
                  // onBlur={calculateCommission}
                  />
                  <Col className={'commission_col mobile-select'}>
                    <InputField
                      labelCol={2}
                      labelItem={t("home.commission")}
                      placeholder=""
                      className="dark-input commission_input isReadOnly"
                      readOnly={true}
                      suffix={fromBranch?.CCY_NAME}
                      name="COMMISSION"
                      // width={'183px'}
                      // height={'40px'}
                      value={commissionAmount}
                      hasLoading={commissionLoading}
                      form={form}
                      ref={formRef}
                    />
                  </Col>
                </div>

                <TextAreaField
                  placeholder={t("salary.transferedToEmployeeAccount")}
                  visible={true}
                  // value={t("salary.transferedToEmployeeAccount")}
                  labelItem={t("salary.toAccount")}
                  readOnly={true}
                  allowAllSymboll
                  value={
                    t("salary.transferedToEmployeeAccount")
                  }
                  name="CUSTACCTO"
                  className={
                    'no_required dark-input account-input salary-input'
                  }
                  showCount={false}
                  minRows={1}
                  form={form}
                  maxLength={'90'}
                />

              <Form.Item
                  label={t("accountStatement.mainPayment")}
                  name={'MAINDET'}
               rules={[
                 {
                     required: true,
                     message: t("newTransfer.requiredField"),

                  },
                ]}
                  validateTrigger="onBlur"
                  >
                  <Select
                      status={hasError && isTouched ? 'error' : ''}

                      style={{
                        width: '100%',

                      }}
                      onChange={(value: string) => handleMainDet(value)}
                      size="large"
                      value={maindetail}
                      // notValid={maindetail===null?'error':''}
                      // required={true}
                      placeholder={t("transfers.select")}
                      disabled={!fromBranch}
                      options={optionsDet}
                      // name={"MAINDET"}
                 />
</Form.Item>

                <TextAreaField
                  visible={true}
                  labelItem={t("accountStatement.additionalPaymentDetails")}
                  placeholder=""
                  showCount={true}
                  maxLength={'90'}
                  name={'PMTDETAIL'}
                  required={false}
                  message={t("newTransfer.requiredField")}
                  form={form}
                  allowLatin={true}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  className={'isReadOnly'}
                />
                <div className={'flex'}>
                  <Col flex={1}>
                    <TextAreaField
                      visible={visible}
                      labelItem={t("newTransfer.note")}
                      placeholder=""
                      showCount={true}
                      maxLength={'180'}
                      name={'NOTE'}
                      // exchange
                      form={form}
                      // allowDestination={true}
                      allowLatin={true}
                      // readOnly={!fromBranch?.ACCOUNT_NO}
                      className={'isReadOnly  not-required isReadOnly plus_minus_area plus_minus_area--salary'}
                    />
                  </Col>
                  <Button
                    className="icon-button add-remove-btn"
                    icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                    onClick={() => setVisible(!visible)}
                  />
                </div>

                <FileUpload
                  className="file-upload"
                  labelItem={t("newTransfer.attachPDF")}
                  form={form}
                  // salary
                  ref={formRef}
                  accept="application/pdf"
                  multiple={false}
                  required={false}
                  name={'pdf_files'}
                  onChange={getFileList}
                  disabled={!form.getFieldValue('CUSTACC')}
                // className="file-upload"
                // labelItem={t("newTransfer.attachPDF")}
                // form={form}
                // nae='pdf_files'
                // convertBase64={convertBase64}
                // handleUpload={handleUpload}
                // accept="application/pdf"
                />
                <Row className="green-upload" justify="end">
                  <Col span={8} style={{justifyContent:"flex-end", display:"flex", marginRight: "10px"}}>
                    <Button
                      size={'large'}
                      icon={<DownloadBtnIco />}
                      style={{ marginTop: 14, width: "auto" }}
                      className="light-button btn save_btn flex align_center justify_center"
                      onClick={() => downloadExcel()}
                    >
                      {BUTTONS.DOWNLOAD_PATTERN}
                    </Button>
                  </Col>
                  <Col span={14}>
                    <FileUploadXls
                      greenUpload
                      disabled={!form.getFieldValue('CUSTACC')}
                      fileList={fileList}
                      propsUpload={propsUpload}
                      onRemove={propsUpload.onRemove}
                      convertBase64={convertBase64}
                      className="file-upload"
                      accept=".xls, .xlsx"
                      handleUpload={handleUpload}
                      width={290}

                    />
                  </Col>
                </Row>

                {/* <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item> */}
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>
      <div id="salary-modal">
        <NextModalSalary
          callBackApi={newTransferFunc}
          visible={nextModalVisible}
          onClose={setNextModalVisible}
          width={1000}
          data={modalData}
          disabledCreate={disabledCreate}
          table_class=" salary-modal__table"
          tableTitle={t("salary.employee")}
          // // tableData={tableData}
          // innerColumnsdata={innerColumnsdata}
          // innerrtableData={innerrtableData}
          columnsData={innerColumnsdata}
          tableData={
            editedTableValue.length > 0 ? editedTableValue : tableDataXls
          }
          transferData
          // columnsData={innerColumnsdata}
          className={'transfer_own_account salary-modal salary-modal__table'}
          nextModalTitle={t("home.transfer")}
          nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
          fileListSalary={fileList}
          documentNumber={documentNumber}
        />
      </div>
      {showSpinner && <FullScreenLoading/>}
    </>
  )
}
const mapStateToProps = (state: any) => ({
  tableData: state.salary.tableValue ? state.salary.tableValue : '',
  editedTableValue: state.salary.editedTableValue,
  companyData:
    state.user && state.user.companyData.result
      ? state.user.companyData.result.customerNo
      : getCurrentCompany().customerNo,
  createdTransferValue: state.salary.createdTransferValue,
})
const mapDispatchToProps = {
  setTableDataSalary,
  setSelectedOption,
  editTableDataSalary,
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferInputs)
